export enum LoadingStatusEnums {
	ERT_LOAD_FAILED = 'ERTLoadFailed'
}
